export const TRACK_NAV_ITEM_CLICK = 'TRACK_NAV_ITEM_CLICK';

export function trackNavItemClick(eventAction, eventLabel) {
  return {
    type: TRACK_NAV_ITEM_CLICK,
    eventAction,
    eventLabel,
  };
}
